/* eslint-disable no-unused-expressions */

import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import './style.scss';

const plusIcon = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-plus-red';
const minusIcon = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-minus-red';

const ManagementTeam = ({ fields = {}, t, params }) => {
  const {
    image,
    imageCardName: title,
    imageCardDescription: subTitle,
    description: leftDescription,
    highlightPointsTitle: rightDescriptionTitle,
    highlightPointsText: rightDescription,
  } = fields;

  const shouldRenderImage = !!image?.value?.src;
  const shouldRenderTitle = !!title?.value;
  const shouldRenderSubTitle = !!subTitle?.value;
  const shouldRenderLeftDescription = !!leftDescription?.value;
  const shouldRenderRightDescriptionTitle = !!rightDescriptionTitle?.value;
  const shouldRenderRightDescription = !!rightDescription?.value;

  const [readMore, setReadMore] = useState(true);

  const descValue = shouldRenderLeftDescription ? { value: leftDescription.value.split(' ', 50).join(' ') } :{ value: '' }

  const [desc, setDesc] = useState(descValue);

  const readMoreClick = () => {
    if (readMore) {
      setDesc({
        value: leftDescription.value,
      });
    } else {
      setDesc({
        value: leftDescription.value.split(' ', 50).join(' '),
      });
    }
    setReadMore((prev) => !prev);
  };

  return (
    <div className={clsx('management__team content', 'add-margins', params?.Styles)}>
      <div className={clsx('management__team-image', !shouldRenderImage && 'no-image')}>
        {shouldRenderImage && <Image field={image} />}
        {(shouldRenderTitle || shouldRenderSubTitle) && (
          <div className="image-content">
            {shouldRenderTitle && (
              <div className="image-content_title">
                <Text field={title} />
              </div>
            )}
            {shouldRenderSubTitle && (
              <RichText className="image-content_subtitle" field={subTitle} />
            )}
          </div>
        )}
      </div>
      <div className="management__team--mobile d-block d-xl-none">
        {shouldRenderLeftDescription && (
          <RichText className="management__team--mobile_top-description" field={desc} />
        )}
        {shouldRenderRightDescriptionTitle && (
          <div
            className={clsx(
              'management__team--mobile_bottom-description_title',
              readMore ? 'd-none' : 'd-block'
            )}
          >
            <Text field={rightDescriptionTitle} />
          </div>
        )}
        {shouldRenderRightDescription && (
          <RichText
            className={clsx(
              'management__team--mobile_bottom-description',
              readMore ? 'd-none' : 'd-block'
            )}
            field={rightDescription}
          />
        )}
        {(shouldRenderRightDescriptionTitle ||
          shouldRenderRightDescription ||
          desc?.value !== leftDescription?.value ||
          !readMore) && (
            <div onClick={readMoreClick} role="button" className="read-button">
              <img src={plusIcon} className={readMore ? 'd-block' : 'd-none'} alt="plus" />
              <img src={minusIcon} className={readMore ? 'd-none' : 'd-block'} alt="minus" />
              <span>{readMore ? t('Read more') : t('Read less')}</span>
            </div>
          )}
      </div>
      <div
        className={clsx(
          'management__team--desktop d-none d-xl-flex',
          !shouldRenderImage && 'no-image'
        )}
      >
        {shouldRenderLeftDescription && (
          <RichText
            className={clsx(
              'management__team--desktop_left-description',
              !shouldRenderRightDescriptionTitle &&
              !shouldRenderRightDescription &&
              'remove-max-width'
            )}
            field={leftDescription}
          />
        )}
        {(shouldRenderRightDescriptionTitle || shouldRenderRightDescription) && (
          <div className="management__team--desktop_right">
            {shouldRenderRightDescriptionTitle && (
              <div className="management__team--desktop_right-title">
                <Text field={rightDescriptionTitle} />
              </div>
            )}
            {shouldRenderRightDescription && (
              <RichText
                className="management__team--desktop_right-description"
                field={rightDescription}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default withTranslation()(ManagementTeam);
